import { useQuery } from "@tanstack/react-query";

import { getFavoriteMatches } from "@/api/favoriteMatches";

export enum FavoriteMatchesQueryKeys {
  All = "favoriteMatches"
}

// The user's favorited match (event) ids. Per-user + cross-device (server
// stored); a favorite is shown only while its match is still in the feed.
export const useFavoriteMatches = () =>
  useQuery({
    queryKey: [FavoriteMatchesQueryKeys.All],
    queryFn: ({ signal }) => getFavoriteMatches({ signal })
  });
